import { render, staticRenderFns } from "./User-Added-To-Folder.vue?vue&type=template&id=77db0389&"
import script from "./User-Added-To-Folder.vue?vue&type=script&lang=js&"
export * from "./User-Added-To-Folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports